skrilla.controller('entityEventLogsModalCtrl', function ($scope, cacheService, modalService, $filter) {
    $scope.log = cacheService.getObject("entityEventLog");
    $scope.log.data = $filter("scanForDateTime")($scope.log.data)
    $scope.isXml = false;
    //Assume that either the whole data is xml or none of it.
    if($scope.log.data.startsWith("<") && $scope.log.data.endsWith(">")){
        $scope.entityEventLogData = $scope.log.data;
        $scope.isXml = true;
    }
    else {
        $scope.entityEventLogData = marked($scope.log.data, {
            gfm: true,
            breaks: true
        })
    }
});

